import FormField from "@src/components/FormField/FormField";
import Input from "@src/components/Input/Input";
import SearchInput from "@src/components/SearchInput/SearchInput";
import Select from "@src/components/Select/Select";
import { useSearchCharacter } from "@src/hooks/useSearchCharacter";
import { Controller, useFormContext, useWatch } from "react-hook-form";
interface IProps {
    submitFn: (data: any) => void;
}

const Links = ({ submitFn }: IProps) => {
    const { handleSubmit, formState, register, setValue, control } =
        useFormContext();

    const watchCharB = useWatch({
        name: "character_B_version_id",
        control: control,
    });
    const watchCharA = useWatch({
        name: "character_A_version_id",
        control: control,
    });
    const { searchLoading, displayResults, setDisplayResults, handleChange } =
        useSearchCharacter();

    return (
        <form onSubmit={handleSubmit(submitFn)}>
            <input {...register("id")} name="id" type="hidden" />
            <FormField name="relationship_type" errors={formState.errors}>
                <Controller
                    name="relationship_type"
                    render={({ field }) => {
                        return (
                            <Select
                                name="relationship_type"
                                onChange={(item) => {
                                    setValue("relationship_type", item, {
                                        shouldDirty: true,
                                        shouldTouch: true,
                                        shouldValidate: true,
                                    });
                                }}
                                options={[
                                    { name: "Friends", id: "friends" },
                                    { name: "Lovers", id: "lovers" },
                                    { name: "Enemies", id: "enemies" },
                                    { name: "Family", id: "family" },
                                    {
                                        name: "Acquaintances",
                                        id: "acquaintances",
                                    },
                                ]}
                                defaultSelected={field.value}
                            />
                        );
                    }}
                />
            </FormField>
            <FormField
                name="character_A_version_id"
                displayName="Character A"
                errors={formState.errors}
            >
                {watchCharA !== undefined ? (
                    <Input
                        name="character_A_version_id-name"
                        displayClearButton={true}
                        register={register}
                        clearSideEffect={() => {
                            //@ts-ignore
                            setValue("character_A_version_id", undefined);
                        }}
                        onClick={() => {
                            //@ts-ignore
                            setValue("character_A_version_id", undefined);
                        }}
                    />
                ) : (
                    <Controller
                        control={control}
                        name="character_A_version_id"
                        render={({ field }) => {
                            return (
                                <>
                                    <SearchInput
                                        placeholder="Enter a name here..."
                                        name="character_A_version_id"
                                        searchResults={
                                            document.activeElement != null &&
                                            document.activeElement.id ==
                                                "character_A_version_id"
                                                ? displayResults
                                                : []
                                        }
                                        onChange={(item) => {
                                            handleChange(item);
                                        }}
                                        isLoading={searchLoading}
                                        onClick={(item) => {
                                            field.onChange(item.id);
                                            setValue(
                                                "character_A_version_id-name",
                                                item.name,
                                            );
                                        }}
                                        onClickOutside={() =>
                                            setDisplayResults([])
                                        }
                                    />
                                </>
                            );
                        }}
                    />
                )}
            </FormField>
            <FormField
                name="character_B_version_id"
                displayName="Character B"
                errors={formState.errors}
            >
                {watchCharB !== undefined ? (
                    <Input
                        name="character_B_version_id-name"
                        displayClearButton={true}
                        register={register}
                        clearSideEffect={() => {
                            //@ts-ignore
                            setValue("character_B_version_id", undefined);
                        }}
                        onClick={() => {
                            //@ts-ignore
                            setValue("character_B_version_id", undefined);
                        }}
                    />
                ) : (
                    <Controller
                        control={control}
                        name="character_B_version_id"
                        render={({ field }) => {
                            return (
                                <SearchInput
                                    placeholder="Enter a name here..."
                                    name="character_B_version_id"
                                    searchResults={
                                        document.activeElement != null &&
                                        document.activeElement.id ==
                                            "character_B_version_id"
                                            ? displayResults
                                            : []
                                    }
                                    onChange={handleChange}
                                    isLoading={searchLoading}
                                    onClick={(item) => {
                                        field.onChange(item.id);
                                        setValue(
                                            "character_B_version_id-name",
                                            item.name,
                                        );
                                    }}
                                />
                            );
                        }}
                    />
                )}
            </FormField>
        </form>
    );
};
export default Links;
